<template>
  <div class="view">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'staff', params: {} }">
        Staff
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :to="{ name: 'staffView', params: {} }">
        View Staff
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card v-if="loaded">
      <v-card-title>
        View Staff
        <v-snackbar
          v-if="!staff.active"
          content-class="text-center"
          color="warning"
          outlined
          :timeout="-1"
          width="100px"
          :value="true"
          absolute
          top
          centered
          >Inactive Staff</v-snackbar
        >
      </v-card-title>
      <v-card-text>
        <div
          class="
            d-flex
            flex-column flex-sm-row
            justify-space-between
            text-subtitle-2
            my-2
          "
        >
          <div>
            {{ staff.firstName }} {{ staff.lastName }}
            <span v-if="ageGender">({{ ageGender }})</span>
            <v-btn
              class="mx-2"
              icon
              :to="{ name: 'staffEdit', params: { id: staff.id } }"
              ><v-icon>mdi-account-edit-outline</v-icon></v-btn
            >

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="removestaff">
                  <v-list-item-title>Delete staff</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <div class="text-caption d-flex flex-column flex-sm-row justify-space-between">
              <span
                v-if="globalCenter && !globalCenter.id"
                class="text-caption"
              >
                {{ getCenterName(staff.centerId) }}
              </span>
              <v-divider
                vertical
                v-if="globalCenter && !globalCenter.id"
                class="mx-2"
              />
              <span>{{ staff.contactTypeName }}</span>
              <v-divider vertical v-if="staff.jobTitle" class="mx-2" />
              <span v-if="staff.jobTitle" class="text-caption">
                {{ staff.jobTitle ? staff.jobTitle:'n/a' }}
              </span>
              <v-divider vertical class="mx-2" />
              <span class="text-caption">
                {{ staff.email ? staff.email:'email: n/a' }}
              </span>
              <v-divider vertical v-if="staff.phone" class="mx-2" />
              <the-mask
                v-if="staff.phone"
                class="text-caption"
                :value="staff.phone"
                :mask="['(###) ###-####']"
              />
            </div>
          </div>
          <div class="my-auto mt-2 my-sm-0 text-caption">
            <v-icon color="orange darken-1" v-if="isBirthday" class="mb-2"
              >mdi-cake-variant-outline</v-icon
            >
            DoB:
            <span v-if="staff.dob">{{ staff.dob | formatDateYear }} </span>
            <span v-else>
              <router-link
                :to="{ name: 'staffEdit', params: { id: staff.id } }"
              >
                n/a
              </router-link>
            </span>
          </div>
        </div>
        <v-divider />

        <div class="d-flex justify-space-between">
          <div class="mt-5">{{ getStaffRequirementStatus() }}</div>
          <v-switch
            :disabled="!staff.active"
            dense
            hide-details
            v-model="multiSubmitMode"
            :label="`Submit Multiple: ${multiSubmitMode ? 'Yes' : 'No'}`"
          ></v-switch>
        </div>

        <v-data-table
          id="staff-view"
          class="my-5"
          :mobile-breakpoint="0"
          :hide-default-footer="true"
          :hide-default-header="true"
          :headers="headers"
          :items="requirements"
          disable-pagination
          group-by="type"
        >
          <template v-slot:group.header="{ group, headers }">
            <td :colspan="headers.length">
              <div class="d-flex justify-space-between">
                <div class="font-weight-bold my-auto">{{ group }}</div>
                <v-alert
                  v-if="group == 'Vaccination' && !staff.dob"
                  class="mt-2"
                  outlined
                  dense
                  type="warning"
                >
                  staff's birthday is required
                </v-alert>

                <v-checkbox
                  v-if="multiSubmitMode && hasIncomplete(group)"
                  v-model="toggle[group]"
                  class="mr-4"
                  @change="toggleGroup(group)"
                />
              </div>
            </td>
          </template>
          <template v-slot:item.name="{ item }">
            <div class="d-flex">
              <div v-if="item.formId" class="mr-2">
                <v-btn
                  color="primary"
                  target="_blank"
                  icon
                  :href="getFormLink(item.formId)"
                  :title="getFormName(item.formId)"
                  ><v-icon>mdi-form-select</v-icon></v-btn
                >
              </div>
              <div class="my-auto">
                <div>
                  {{ item.name }} <span v-if="!item.required">(Optional)</span>
                </div>
                <div class="text-caption">
                  <span v-if="item.attachmentRequired"
                    ><small>Require proof</small></span
                  >
                </div>
              </div>
              <!-- <attachments-view class="ml-1" v-if="item.attachments && item.attachments.length > 0" v-model="item.attachments" :inline="false"/> -->
            </div>
          </template>
          <template v-slot:item.status="{ item }">
            <v-list v-if="item.status && item.status.length > 0">
              <template v-for="(s, index) in item.status">
                <v-list-item :key="`${s.id}_${index}`">
                  <v-list-item-content>
                    <staff-requirement-status
                      :key="ts"
                      :disabled="!staff.active"
                      v-model="item.status[index]"
                      :requirement="item"
                      :staff="staff"
                      :selectMode="multiSubmitMode"
                      @selectionChanged="submissionSelectionChanged"
                    />
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
            <div v-else class="text-weight-light mx-4">No status</div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <div class="d-flex justify-space-between ma-5">
      <v-btn @click="goBack">Back</v-btn>
      <!-- <v-btn @click="edit(id)" color="primary">Edit</v-btn> -->
      <span></span>
    </div>

    <v-snackbar timeout="-1" color="primary" v-model="multiSubmitMode">
      {{ selected.length }} requirements selected
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          :disabled="selected.length < 1"
          @click="submitMultiple"
        >
          Submit
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog width="300" v-model="guardianDialog">
      <staff-guardians :staff="staff" :key="staff.id" />
    </v-dialog>
    <confirmation-dialog ref="confirm" />
  </div>
</template>

<script>
import { config } from '@/config'
import { mapActions, mapGetters } from "vuex";
import { getStaff } from "@/services/staff";
import { getStaffRequirements } from "@/services/requirement";
import moment from "moment";
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");
const StaffRequirementStatus = () =>
  import("@/components/staff/StaffRequirementStatus.vue");
import { TheMask } from "vue-the-mask";
import { parseDomain } from "parse-domain";

export default {
  components: { StaffRequirementStatus, ConfirmationDialog, TheMask },
  data() {
    return {
      id: "",
      multiSubmitMode: false,
      toggle: {},
      selected: [],
      staff: {},
      loaded: false,
      relations: {},
      requirements: [],
      forms: [],
      ts: Date.now(),
      guardianDialog: false,
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
          sortable: true,
        },
        {
          text: "Status",
          value: "status",
          align: "start",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("auth", ["myCenters"]),
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"]),

    ageGender() {
      let info = "";
      if (this.staff.dob) {
        const ageYears = moment().diff(this.staff.dob, "years", false);
        info += `${ageYears} y.o`;
      }
      if (this.staff.gender) {
        if (info) {
          info += ` ${this.staff.gender} `;
        } else {
          info = this.staff.gender;
        }
      }
      return info;
    },
    isBirthday() {
      if (this.staff.dob) {
        const dob = moment(this.staff.dob).format("MMDD");
        const today = moment().format("MMDD");
        return dob === today;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),
    ...mapActions("staff", ["deleteStaff"]),
    goBack() {
      this.$router.go(-1);
    },
    edit(id) {
      this.$router.push({ name: "staffEdit", params: { id: id } });
    },
    setInstance() {
      this.setDependencies().then(() => {
        getStaff(this.id)
          .then((response) => {
            this.staff = response.data;
            this.loaded = true;
          })
          .catch(() => {
            this.addErrorMessage("Error loading staff");
            this.loaded = true;
          });
      });
    },
    async setDependencies() {
      getStaffRequirements([this.id].join(",")).then((response) => {
        this.requirements = response.data;
        if (this.requirements && this.requirements.length > 0) {
          this.requirements.forEach((r) => {
            if (r.status) {
              r.status = Object.values(r.status);
            }

            if (r.attachments) {
              r.attachments.forEach((file) => {
                const path = `${config.BASE_URL}/compliance/requirement/attachment/${file.id}`;
                file.path = path;
              });
            }
          });

          //fetch associated forms
          this.initForms();
        }
      });
    },
    getRelationText(id, relationProperty, relationAttribute) {
      const relationList = this.relations[relationProperty];
      if (relationList) {
        const relationObj = relationList.find((r) => r.id == id);
        return relationObj[relationAttribute];
      } else {
        return "";
      }
    },
    submitMultiple() {
      const requirements = this.selected.map((r) => {
        if (r.type == "Vaccination") {
          return `${r.requirementId}_${r.forDoseNumber}`;
        } else {
          return `${r.requirementId}`;
        }
      });
      const route = {
        path: `/staffRequirementSubmission/create`,
        query: {
          staffId: this.staff.id,
          requirements: requirements.join(","),
        },
      };
      this.$router.push(route);
    },
    submissionSelectionChanged({ state, requirement, forDoseNumber }) {
      console.log("Selected: ", requirement, forDoseNumber);
      if (state === true) {
        const r = Object.assign({}, requirement);
        r.forDoseNumber = forDoseNumber;
        this.selected.push(r);
      } else {
        const selectedIndex = this.selected.findIndex(
          (r) => r.id == requirement.id
        );
        if (selectedIndex > -1) {
          this.selected.splice(selectedIndex, 1);
        }
      }
    },
    getStaffRequirementStatus() {
      if (this.requirements) {
        let statuses = [];
        this.requirements.forEach((r) => {
          if (r.status) {
            statuses = statuses.concat(Object.values(r.status));
          }
        });
        if (statuses.length > 0) {
          const completedCount = statuses.filter(
            (s) => s.state == "completed" || s.state == "pending"
          ).length;
          const incompleteCount = statuses.filter(
            (s) => s.state == "incomplete"
          ).length;
          const totalCount = completedCount + incompleteCount;
          return `${completedCount} of ${totalCount} requirements completed`;
        } else {
          return "Status: n/a";
        }
      }
    },
    async removestaff() {
      let confirm = await this.$refs.confirm.open(
        "Confirm Delete",
        "Please confirm you want to delete this staff?"
      );
      if (confirm) {
        if (this.staff && this.staff.id) {
          this.deleteStaff(this.staff.id)
            .then(() => {
              this.addSuccessMessage("staff was deleted successfully");
              this.$router.push({ name: "staff" });
            })
            .catch(() => {
              this.addErrorMessage("Error deleting staff");
            });
        }
      }
    },
    toggleGroup(group) {
      this.selected = [];
      const groupRequirements = this.requirements.filter(
        (r) => r.type == group
      );
      if (this.toggle[group]) {
        groupRequirements.forEach((req) => {
          req.status
            .filter((s) => !s.submissionDate)
            .forEach((status) => {
              status.selected = true;
              const state = status.selected;
              const doseNumber = status.dose ? status.dose : 1;
              this.submissionSelectionChanged({
                state,
                requirement: req,
                forDoseNumber: doseNumber,
              });
            });
        });
      } else {
        groupRequirements.forEach((req) => {
          req.status
            .filter((s) => !s.submissionDate)
            .forEach((status) => {
              status.selected = false;
              const state = status.selected;
              const doseNumber = status.dose ? status.dose : 1;
              this.submissionSelectionChanged({
                state,
                requirement: req,
                forDoseNumber: doseNumber,
              });
            });
        });
      }

      this.ts = Date.now();
    },
    hasIncomplete(group) {
      let incompleteCount = 0;
      const groupRequirements = this.requirements.filter(
        (r) => r.type == group
      );
      groupRequirements.forEach((req) => {
        incompleteCount = req.status
          ? req.status.filter((s) => !s.submissionDate).length
          : 0;
      });

      return incompleteCount > 0 ? true : false;
    },
    getCenterName(id) {
      if (this.myCenters && this.myCenters.length > 0) {
        const center = this.myCenters.find((c) => c.id == id);
        return center ? center.name : "Location N/A";
      } else {
        return "Location N/A";
      }
    },
    viewGuardian() {
      console.log("viewGuardian...");
      this.guardianDialog = true;
    },
    async initForms() {
      if (this.requirements) {
        const formIds = this.requirements
          .filter((r) => r.formId)
          .map((r) => r.formId);
        if (formIds && formIds.length > 0) {
          const params = {
            formIds: formIds.join(","),
          };
          return await this.$axios
            .get("/form/get-forms", { params })
            .then((resp) => {
              this.forms = resp.data;
            });
        }
      }
    },
    getFormLink(formId) {
      const onlineForm = this.forms.find((f) => f.id == formId);
      if (onlineForm) {
        if (process.env.NODE_ENV != "development") {
          const parseResult = parseDomain(window.location.hostname);
          const { domain, topLevelDomains } = parseResult;
          const topLevel = topLevelDomains.join(".");

          return `https://form.${domain}.${topLevel}/#/${onlineForm.accountName}/form/${onlineForm.id}`;
        } else {
          return `http://localhost:8086/#/${onlineForm.accountName}/form/${onlineForm.id}`;
        }
      } else {
        return null;
      }
    },
    getFormName(formId) {
      const onlineForm = this.forms.find((f) => f.id == formId);
      return onlineForm ? onlineForm.name : null;
    },
  },
  created() {
    this.id = this.$route.params.id;

    this.setInstance();
    this.$emit("showParent", false);
  },
};
</script>
<style>
#staff-view > .v-data-table__wrapper > table > tbody > tr:hover {
  background: inherit !important;
}
#staff-view > .v-data-table__wrapper > table > tbody > tr.v-row-group__header {
  background: #f5f5f5 !important;
}
</style>
